import request from '@/utils/request'

// 登录：POST account + password
export function login(data) {
  return request.post('/auth/login', data)
}

// 会话信息：启动时校验 token + 刷新主体资料
export function getInfo() {
  return request.post('/auth/info')
}

// 退出登录
export function logout() {
  return request.post('/auth/logout')
}

// 修改密码：POST oldpassword + newpassword（改密后当前会话被踢，需重新登录）
export function changePwd(oldpassword, newpassword) {
  return request.post('/auth/changepwd', { oldpassword, newpassword })
}
